import getStore, { defaultCalendarSearchStoreData } from '../store/store';
import { mutator } from 'satcheljs';
import {
    clearRefiners,
    setFromDate,
    setIncludeAttachments,
    setToDate,
} from '../actions/searchStoreActions';

mutator(setFromDate, actionMessage => {
    getStore().fromDate = actionMessage.fromDate;
});

mutator(setToDate, actionMessage => {
    getStore().toDate = actionMessage.toDate;
});

mutator(setIncludeAttachments, actionMessage => {
    getStore().includeAttachments = actionMessage.includeAttachments;
});

mutator(clearRefiners, () => {
    const calendarSearchStore = getStore();

    // Reset refiners.
    calendarSearchStore.fromDate = null;
    calendarSearchStore.toDate = null;
    calendarSearchStore.includeAttachments = defaultCalendarSearchStoreData.includeAttachments;
    calendarSearchStore.calendarFoldersScope = calendarSearchStore.calendarFoldersScope.map(
        item => {
            item.displayName = item.displayName;
            item.folderId = item.folderId;
            item.isSelected = true;
            return item;
        }
    );
});
